export default __webpack_public_path__ + "static/planes-a23e77ff8f1cf9089b4ea7d3b2ef866c.webp";